import { grey } from '@mui/material/colors';

export const Input = {
  MuiInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '16px',
        fontWeight: 600,
        color: grey[500],
        '&.quantityField': {
          border: `1px solid ${grey[400]}`,
          borderRight: 'none',
          borderLeft: 'none',
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        backgroundColor: '#fff',
        '& MuiInputBase-input': {
          zIndex: 1,
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        zIndex: 1,
      },
    },
  },
};

//this is the text beneath the inputs - generally used for errors
export const HelperText = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: '.75rem', // 12px
      },
    },
  },
};
